import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  bar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 16,
    padding: '4px 24px 4px 12px',
    backgroundColor: theme.palette.common.white,
    boxShadow: `inset 0px -1px 0px 0px ${theme.palette.dividerV2.main}`,
  },
  group: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  label: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.labraText.primary,
    whiteSpace: 'nowrap',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    height: 32,
    padding: '6px 8px 6px 12px',
    border: 'none',
    borderRadius: 8,
    backgroundColor: theme.palette.graphColors.secondary,
    cursor: 'pointer',
  },
  chipText: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.labraText.tertiary,
    whiteSpace: 'nowrap',
  },
  chipValue: {
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 500,
    letterSpacing: '0.5px',
  },
  chipIcon: {
    fontSize: 14,
    color: theme.palette.labraText.description,
  },
  overflowChip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    padding: '6px 9px',
    border: 'none',
    borderRadius: 8,
    backgroundColor: theme.palette.graphColors.secondary,
    cursor: 'default',
  },
}))
